import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminSideMenu from "./components/sideMenu/SideMenu";

// Pages
import AddManagerPage from "./pages/AddManagerPage/AddManagerPage";
import AdminHome from "./pages/homePage/AdminHome";
import AllEmployeesPage from "./pages/employeesPage/EmployeesPage";
import ClientsPage from "./pages/clientsPage/ClientsPage"; // ✅ new import
import NotificationsPage from "./pages/notifications/NotificationsPage";
import PaymentsPage from "./pages/paymentsPage/PaymentsPage";
import ProjectsPage from "./pages/projectsPage/ProjectsPage";

// Emails page (new)
import EmailsPage from "./pages/emailsPage/EmailsPage";

export default function AdminLayout() {
  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className="layout-sidebar">
        <AdminSideMenu />
      </aside>

      {/* Main Content */}
      <main className="layout-main admin-home">
        <Routes>
          {/* Dashboard shown for both /admin and /admin/dashboard */}
          <Route index element={<AdminHome />} />
          <Route path="dashboard" element={<AdminHome />} />

          {/* Admin Routes */}
          <Route path="add-manager" element={<AddManagerPage />} />
          <Route path="employees" element={<AllEmployeesPage />} />
          <Route path="clients" element={<ClientsPage />} /> {/* ✅ new route */}
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="projects" element={<ProjectsPage />} />

          {/* Emails route (new) */}
          <Route path="emails" element={<EmailsPage />} />

          {/* Future admin routes */}
          {/* <Route path="stats" element={<Stats />} /> */}
          {/* <Route path="reports" element={<Reports />} /> */}

          {/* Fallback */}
          <Route path="*" element={<h2>404 - Page not found</h2>} />
        </Routes>
      </main>
    </div>
  );
}
